import React, { FC, useState, useEffect } from "react";
import ICImage from "../core-component/ICImage";
import VideoPlayer from "./common/VideoPlayer";
import { MEDIA_TYPE } from "../utils/AppEnumerations";
import { IServiceForSubCategory } from "../screens/product-services/Web/ProductServiceDetailsWebController";
import Modal from "./PublicModal";
import { leftChevronIcon, rightChevronIcon } from "../assets/icons/SvgIconList";

interface ICarouselItem {
  id: number;
  title: string;
  pos: number;
  media_url: string;
  media_type: string;
}

interface IPublicServiceCarouselProps {
  items: IServiceForSubCategory[];
}

const PublicServiceCarousel: FC<IPublicServiceCarouselProps> = ({ items }) => {
  const [carouselItems, setCarouselItems] = useState<ICarouselItem[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [serviceId, setServiceId] = useState<number>();
  const [currentIndex, setCurrentIndex] = useState(0);
  let timer: NodeJS.Timeout;

  useEffect(() => {
    const initializedItems: false | ICarouselItem[] =
      items &&
      items.length > 0 &&
      items.flatMap((item, index) => ({
        id: item.id,
        title: item.service_title,
        pos: index - Math.floor(items.length / 2),
        media_url: item.app_media[0].media_url,
        media_type: item.app_media[0].media_type,
      }));
    initializedItems && setCarouselItems(initializedItems);
    initializedItems &&
      initializedItems.length > 0 &&
      setCurrentIndex(Math.floor(initializedItems.length / 2));
  }, [items]);

  const updatePositions = (newIndex: number) => {
    carouselItems &&
      carouselItems.length > 0 &&
      setCarouselItems(
        carouselItems.map((item, index) => ({
          ...item,
          pos: index - newIndex,
        }))
      );
  };

  const handleSlideClick = (id: number) => {
    setServiceId(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleCarouselSlide = (direction: "left" | "right") => {
    let newIndex = currentIndex;
    if (direction === "left") {
      newIndex =
        (currentIndex - 1 + carouselItems.length) % carouselItems.length;
    } else {
      newIndex = (currentIndex + 1) % carouselItems.length;
    }
    setCurrentIndex(newIndex);
    updatePositions(newIndex);
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      let newIndex = currentIndex;
      newIndex = (currentIndex + 1) % carouselItems.length;
      setCurrentIndex(newIndex);
      updatePositions(newIndex);
    }, 2000);
    return () => clearTimeout(timer);
  });
  return (
    <div>
      <div className="carousel !w-full overflow-hidden">
        <ul className="carousel__list relative">
          {carouselItems &&
            carouselItems.length > 0 &&
            carouselItems.map((item) => (
              <li
                key={item.id}
                className={`carousel-item aspect-16/9 ${
                  item.pos === 0 ? "carousel-item-active" : ""
                }`}
                data-pos={item.pos}
              >
                {item.media_type === MEDIA_TYPE.video ? (
                  <VideoPlayer
                    control={[
                      "play",
                      "progress",
                      "current-time",
                      "mute",
                      "fullscreen",
                      "volume",
                      "play-large",
                    ]}
                    source={item.media_url}
                  />
                ) : (
                  <ICImage
                    className="w-full relative aspect-[16/9]"
                    imageUrl={item.media_url}
                    alt={`Carousel item ${item.id}`}
                  />
                )}
                {item.pos === 0 && (
                  <div
                    onClick={() => handleSlideClick(item.id)}
                    className="absolute h-full text-skin-title-insights z-[998] text-2xl"
                  >
                    <div className="flex justify-start items-end h-full p-2">
                      {item.title}
                    </div>
                  </div>
                )}
              </li>
            ))}
          <div className="absolute top-[50%] flex justify-between w-4/5">
            <div
              className="h-10 w-10 z-[999]"
              onClick={() => handleCarouselSlide("left")}
            >
              {leftChevronIcon}
            </div>
            <div
              className="h-10 w-10 z-[999]"
              onClick={() => handleCarouselSlide("right")}
            >
              {rightChevronIcon}
            </div>
          </div>
        </ul>
      </div>
      {isModalOpen && serviceId && (
        <Modal id={serviceId} closeModal={closeModal} />
      )}
    </div>
  );
};

export default PublicServiceCarousel;
